import globals from '../../globals/communityGlobals';

const locale = globals.getArea('error');

// A factory to create reducers for user messages.
// errorCases: which actions should be displayed as errors to the user
// successCases: which actions should be displayed as success messages to the user
// resetErrorCases: which actions should clear error messages
// resetSuccessCases: which actions should clear success messages
// resetCases: which actions should clear both success and error messages
const userMessagesReducerFactory = (errorCases, successCases, resetErrorCases, resetSuccessCases, resetCases) => {
  const initialState = { failure: '', success: '' };
  return (state = initialState, action) => {
    if (errorCases.includes(action.type)) {
      const { translationKey, parameters } = action.message;
      return {
        ...state,
        failure: `${locale.getMsg(translationKey, parameters)}\n`,
      };
    } else if (successCases.includes(action.type)) {
      return {
        ...state,
        success: `${state.success + locale.getMsg(action.message)}\n`,
      };
    } else if (resetErrorCases.includes(action.type)) {
      return {
        ...state,
        failure: '',
      };
    } else if (resetSuccessCases.includes(action.type)) {
      return {
        ...state,
        success: '',
      };
    } else if (resetCases.includes(action.type)) {
      return initialState;
    }
    return state;
  };
};

export default userMessagesReducerFactory;
